// src/services/sourcexTourStore.js
//
// SourceX built documents' guided tour (2026-10-29): has this person already been
// asked "Would you like a tour?" here? Asked once per person, company and site;
// "Show me" and "No thanks" are both remembered. Browser-only (localStorage, no PHI),
// every read and write in try/catch: if storage is unavailable the question is
// simply asked again next time, nothing breaks.

const PREFIX = "regx:sourcexTour:v1";

/** The storage key for one person at one company + site. */
export const tourKey = ({ uid, tenantId, siteId } = {}) =>
  `${PREFIX}:${uid || "anon"}:${tenantId || "-"}:${siteId || "-"}`;

// Read inside the try: touching window.localStorage itself can throw when blocked.
const browserStorage = () => (typeof window !== "undefined" ? window.localStorage : null);

export const hasAnsweredTour = (who, storage) => {
  try {
    const s = storage === undefined ? browserStorage() : storage;
    return !!(s && s.getItem(tourKey(who)));
  } catch {
    return false;
  }
};

/** `answer`: "taken" | "declined". */
export const markTourAnswered = (who, answer, storage) => {
  try {
    const s = storage === undefined ? browserStorage() : storage;
    if (s) s.setItem(tourKey(who), JSON.stringify({ answer, at: new Date().toISOString() }));
  } catch {
    // Storage blocked (private window, cleared data): ask again next time.
  }
};
